module.exports = __webpack_public_path__ + "img/address.0cba6ac3.svg";